import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { WidgetDateV0Utils } from './widget-date-v0.utils';
import { IoniconsOutline } from '@pt/pt-models';
import { CustomAdapter, CustomDateParserFormatter, WidgetDateOutput } from './widget-date-v0-edit.component';
import { NgbDateAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'pt-widget-date-v0-autosave',
  template: `
    <ng-container *ngIf='loading; then LOADING; else PREVIEW'></ng-container>

    <ng-template #LOADING>
      Loading ...
    </ng-template>

    <ng-template #PREVIEW>
        <div class='input-group input-group-sm pt-widget-date-v0-preview'>
          <div class="disabled-div">

          </div>
          <input
            class="form-control input-calendar"
            aria-describedby="dateHelp"
            [ngClass]="{'is-invalid': !validDate}"
            placeholder="dd/MM/yyyy"
            container="body"
            name="d2"
            [disabled]="disabled"
            [(ngModel)]="modelDate"
            (ngModelChange)="changeTimestampValue($event)"
            ngbDatepicker
            #d2="ngbDatepicker" />

          <button class="btn btn-outline-secondary btn-calendar-autosave"
                  [disabled]="disabled"
                  (click)="d2.toggle()" type="button">
            <pt-icon class="d-flex" [key]='IconCalendar' [size]='16'></pt-icon>
          </button>
        </div>
    </ng-template>
  `,
  styles: [
    `
      .pt-widget-date-v0-preview {
        width: 235px;
        position: relative;
        z-index: 3;
      }

      .disabled-div {
        width: 194px;
        position: absolute;
        z-index: 16;
        background: #f1f1f121;
        top: 0;
        left: 0;
        height: 100%;
      }

      .pt-widget-date-v0-preview input {
        background: white;
      }

      .input-calendar {
        height: 25px;
        border-radius: 0;
        font-size: 0.875rem;
      }

      .btn-calendar-autosave {
        padding: 0 10px;
        height: 25px;
        border-radius: 0;
        display: flex;
        align-items: center;
      }
      .btn-calendar-autosave:hover {
        background: #D6E4FF;
        color: #6c757d;
      }

      .pt-widget-date-v0-edit {
        width: 235px;
      }

      .pt-widget-date-v0-edit input {
        background: white;
      }
    `
  ],
  providers: [
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }
  ]
})
export class WidgetDateV0AutosaveComponent implements OnChanges {
  @Input() noDataLabel?: string;
  @Input() value: number;
  @Input() disabled = true;
  @Input() loading: boolean;
  @Input() currentLanguage: string;

  @Output() changeDateAndSave = new EventEmitter<WidgetDateOutput>();
  public modelDate: number;
  public IconCalendar = IoniconsOutline.calendarCheck;
  public validDate = true;

  textDate: string;
  noData: boolean;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.value) {
      this.noData = !Number.isSafeInteger(this.value);
      this.modelDate = this.value ? JSON.parse(JSON.stringify(this.value)) : null;

      this.textDate = WidgetDateV0Utils.timestampToString(this.value, this.currentLanguage);
      this.changeTimestampValue(this.modelDate);
    }
  }

  changeTimestampValue($event: number) {
    if (Number.isSafeInteger($event) && $event > 0) {
      this.validDate = true;
      const r: WidgetDateOutput = {
        timestamp: $event,
        error: false,
      }
      this.changeDateAndSave.emit(r);
    } else {
      this.validDate = true;  // ho tolto la validazione
      const r: WidgetDateOutput = {
        timestamp: null,
        error: $event !== null && $event !== undefined
      }
      this.changeDateAndSave.emit(r);
    }
  }
}
